import { ApiDouaneType } from "lib/api";

export interface ItemValue {
  label: string;
  multiplier: number;
  count: number | string;
}

export function calcTotal(
  value: ItemValue[],
  type: ApiDouaneType,
  initialStock: number
): number {
  const total = value.reduce<number | undefined>(
    (prev, cur) => {
      if (typeof cur.count !== "string") {
        return (prev ? prev : 0) + cur.count * cur.multiplier;
      }
      return prev;
    },
    type === ApiDouaneType.FULL ? undefined : initialStock
  );
  return total !== undefined ? total : initialStock;
}
